import { useMutation, useQueryClient } from '@tanstack/react-query';
import { PROVIDED_JOB_POST_LISTS_QUERY_KEY } from './useProvidedJobPostLists';
import { PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY } from './useProvidedJobPostListShow';

type UpdateParams = {
  id: string;
  name?: string;
  isPublic?: boolean;
};

export default function useUpdateProvidedJobPostList() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, name, isPublic }: UpdateParams) => {
      const csrfToken =
        document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') || '';
      const body: Record<string, unknown> = {};
      if (name !== undefined) body.name = name;
      if (isPublic !== undefined) body.is_public = isPublic;

      const response = await fetch(`/agent/api/provided_job_post_lists/${id}.json`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': csrfToken,
        },
        body: JSON.stringify({ provided_job_post_list: body }),
      });
      if (!response.ok) {
        let errorMessage = 'Failed to update list';
        try {
          const error = await response.json();
          errorMessage = error.error || errorMessage;
        } catch {
          // JSONパースに失敗した場合はデフォルトメッセージを使用
        }
        throw new Error(errorMessage);
      }
      return response.json();
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: [PROVIDED_JOB_POST_LISTS_QUERY_KEY] });
      queryClient.invalidateQueries({
        queryKey: [PROVIDED_JOB_POST_LIST_SHOW_QUERY_KEY, variables.id],
      });
    },
  });
}
